<p><span><span style="color: #404040;"><span><span lang="en-GB">Doughnut chart:</span></span></span></span></p>
<ul>
  <li>
    <p>
      <span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >The doughnut charts show the degree of the achievement of targets. If YTD is selected as timeframe, it shows the target
              achievement for YTD compared to the target for YTD (= all past months of the current year including the current month). If a
              previous year is selected as timeframe, it shows the target achievement in December of the selected year compared to the
              target for the whole selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"
          ><span
            ><span lang="en-GB"
              >: The icon indicates, whether the target regarding the number of new leads, opportunities, customers or sold boluses is met (</span
            ></span
          ></span
        ><span style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span><span lang="en-GB">) or missed (</span></span></span
        ><span style="color: #ffc000;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span><span lang="en-GB">).</span></span></span
        ></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB"><br /><br /></p>
<p><span><span style="color: #404040;"><span><span lang="en-GB">Bar chart:</span></span></span></span></p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGMJPPzzPwMewIJPclQBCQoAbPUDOZY/PH4AAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Number of new leads per quarter / half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGMxX57/nwEPYMEnOaqABAUAXpYCeaAOx+QAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Number of new opportunities per quarter / half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNxObj4PwMewIJPclQBCQoA3sIC1K/8VbIAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Number of new customers per quarter / half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p>
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNJXmr+nwEPYMEnOaqABAUASzwCa45pqukAAAAASUVORK5CYII="
            alt=""
          />&nbsp; &nbsp; Sold boluses per quarter / half-year</span
        ></span
      ></span
    ></span
  >
</p>
<p style="margin-bottom: 10px;">
  <span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
            alt=""
          />&nbsp; &nbsp; Previous year values for new leads, new opportunities, new customers, sold boluses
        </span></span
      ></span
    ><span style="color: #404040;"
      ><span
        ><span lang="en-GB"
          ><em
            >(depending on position of bar: if the bar is before the leads-bar, it represents the number of new leads in the same quarter /
            half-year prior to the selected year)</em
          ></span
        ></span
      ></span
    ></span
  >
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 12px;
  }
</style>
